<template>
  <div style="margin-bottom: 10px">
    <!-- 简介框 -->
    <div :class="{ introduce: true, specialStyle: dataType == 2 }">
      <div class="introduce-l">
        <div class="introduce-l-input" v-if="dataType == 2">
          <img @click="barrageChange()" :title="barrage ? '关闭弹幕' : '开启弹幕'" :src="barrage ? require('../../assets/image/images/arrage_close.png') : require('../../assets/image/images/arrage_open.png')" alt="" />
          <input type="text" placeholder="发个弹幕吧！！！" @keyup.enter="sendMessage" v-model="barrageData" /><button @click="sendMessage()">发送</button>
        </div>
        <div class="introduce-l-barrage" v-show="barrage">
          <ul>
            <li v-for="(item, ind) in barrageCont" :key="ind">
              <span>{{ item.userName }}：{{ item.cm }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="introduce-r">
        <div class="introduce-r-p zhuanfa" v-show="showP" style="position:relative;">
          <div class="suspend" v-for="(item, ind) in contents" :key="ind" v-show="ind == 1 || ind == 3" @click="repeat(ind, '', item)">
            <!-- ind>0 && !(!getQuery('dataType')&&ind==3) -->
            <a href="javascript:;" >{{ item }}</a>
          </div>
          <div v-show="suspendShow && !IsMobile()" @mouseenter="suspendShow = true" style="width: 640px; height: 360px; box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); backgroundcolor: #fff; position: absolute; top: 0; right: 110px">
            <iframe :src="iframeUrl" id="iframe" width="100%" height="100%" frameborder="0"></iframe>
          </div>
        </div>
        <div class="introduce-r-p pinglun" v-show="showL">
          <div class="suspend" v-for="(item, ind) in ['评论','对话']" :key="ind"  @click="plrepeat(ind, '', item)">
            <a href="javascript:;">{{ item }}</a>
          </div>
        </div>
        <div class="introduce-r-div" @click="changOption('t')" title="点赞">
          <img :src="parseInt(initData.like) ? require('../../assets/image/images/fabulous_curr.png') : require('../../assets/image/images/fabulous.png')" />
          <span>{{ initData.likeNum }}</span>
        </div>
        <!-- ------------评论--------------- -->
        <div class="introduce-r-div" @click="pinglun()" title="评论">
          <img :src="require('../../assets/image/images/comment.png')" />
          <span>{{ initData.commentNum }}</span>
        </div>
        
        <!-- -------------转发-------------- -->
        <div class="introduce-r-div" @click="repeats()" title="转发">
          <img :src="require('../../assets/image/images/forward.png')" />
          <span>{{ initData.forwards.length }}</span>
        </div>
        
        <!-- -------------收藏-------------- -->
        <div class="introduce-r-div" @click="changOptions('t')" title="收藏">
          <img :src="parseInt(initData.collect) ? require('../../assets/image/images/Collection_curr.png') : require('../../assets/image/images/Collection.png')" />
          <span>{{ initData.collectNum }}</span>
        </div>
        <div class="introduce-r-div" @click="downLoad()" title="下载">
          <img :src="require('../../assets/image/images/download_icon.png')" />
          <span>{{ initData.xzNum }}</span>
        </div>
      </div>
    </div>
    <!-- 评论框 -->
    <div class="comment">
      <div class="LikePeople" v-show="initData.likeNames">
        <span :title="initData.likeNames">{{ initData.likeNames }}</span>
      </div>
      <div v-for="(ite, ind) in content" :key="ind" class="line">
        <div class="line-l">
          <span class="name">{{ ite.userName }}</span>
          <span v-if="ite.toUserName" class="rep">回复</span>
          <span class="name" v-if="ite.toUserName">{{ ite.toUserName }}</span>
          <span class="content">: {{ ite.texts }}</span>
        </div>
        <div class="line-r">
          <div class="delete" v-if="(creatUserId && creatUserId == $store.state.userInfo.userId) || (ite.userId && $store.state.userInfo.userId == ite.userId)">
            <div @click="deletes(ite.id)">
              <img :src="require('../../assets/image/images/delete.png')" />
              <span style="fontsize: 13px">删除</span>
            </div>
          </div>
          <div class="reply" @click="reflexs(ite, ind)">
            <img :src="require('../../assets/image/images/comment.png')" />
            <span>回复</span>
          </div>
        </div>
      </div>
      <div class="reflex" v-show="reflex">
        <textarea name="text" id="textarea" :placeholder="placeholder" v-model="notedata"></textarea>
        <div class="Submit">
          <button @click="sub()">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../../bus.js'
export default {
  name: 'pinglun',
  data() {
    return {
      barrageData: '',
      barrageCont: [],
      barrage: true,
      contents: ['转发到商圈', '直接转发', '转发到好友圈', '重新转发', '更新发布', '分享'],
      creatUserId: '',
      iframeUrl: '',
      suspendShow: false,
      suspend: this.getQuery('dataType') ? true : false,
      otherDatas: {},
      showP: false,
      showL:false,
      initData: { like: 0, likeNum: 0, commentNum: 0, collect: 0, collectNum: 0, transmitNum: 0, forwards: 0 },
      placeholder: '评论',
      reflex: this.$store.state.isOrNotXgwz ? true : false,
      content: [],
      notedata: '',
      newIndex: -1,
      contentIds: '',
      pic: '',
      index: -1,
      userId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('noLoginSid'),
      // userId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : 'e9f77a6c-7c19-4eec-aed2-10178628f04f',
      userName: this.$store.state.userInfo.trueName ? this.$store.state.userInfo.trueName : this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('wxud'),
      photo: this.$store.state.userInfo.photo ? this.$store.state.baseURL + `/cme-sso-app/showimg/${JSON.parse(this.$store.state.userInfo.photo)[0].id}` : '',
      titleCont: '',
      appName: '共享世界',
      contentDatas: '',
      picurl: '',
      summary: '',
      textBody: '',
      textEnding: ''
    }
  },
  props: {
    contentId: Array,
    dataType: Number
  },
  mounted() {
    var _this = this
    _this.contentDatas = _this.contentId ? _this.contentId : JSON.parse(sessionStorage.getItem('contentDatas')) || []
    _this.picurl = encodeURIComponent(_this.$store.state.baseURL + '/cme-sso-app/showimg/648638977896648704.png')
    var num = _this.matching(_this.contentDatas)

    var title = _this.contentDatas && _this.contentDatas[num] && _this.contentDatas[num][0] && _this.contentDatas[num][0].standardData ? _this.contentDatas[num][0].standardData : '共享世界'

    if (_this.contentId && _this.contentId[0] && _this.contentId[0][0] && _this.contentId[0][0].contentId) {
      _this.contentIds = _this.contentId[num][0].contentId

      _this.filtrateOnePics(_this.contentId)
    }
    _this.titleCont = title
    _this.otherData()
    _this.contentData()

    _this.summary = _this.contentDatas && _this.contentDatas[num] ? (_this.contentDatas[num].filter((tags) => tags.standardName && tags.standardName == '简介').length ? _this.contentDatas[num].filter((tags) => tags.standardName && tags.standardName == '简介')[0].standardData.replace(/(\r\n)|(\n)/g, '') : '') : ''
    _this.textBody = _this.contentDatas && _this.contentDatas[num] ? (_this.contentDatas[num].filter((tags) => tags.standardName && tags.standardName == '正文').length ? _this.contentDatas[num].filter((tags) => tags.standardName && tags.standardName == '正文')[0].standardData.replace(/(\r\n)|(\n)/g, '') : '') : ''
    _this.textEnding = _this.contentDatas && _this.contentDatas[num] ? (_this.contentDatas[num].filter((tags) => tags.standardName && tags.standardName == '结尾').length ? _this.contentDatas[num].filter((tags) => tags.standardName && tags.standardName == '结尾')[0].standardData.replace(/(\r\n)|(\n)/g, '') : '') : ''

    if (_this.contentDatas && _this.contentDatas[num]) {
      for (var i = 0; i < _this.contentDatas[num].length; i++) {
        if (_this.isPic(_this.contentDatas[num][i].standardData)) {
          _this.picurl = encodeURIComponent(_this.contentDatas[num][i].standardData)
          break
        }
      }
    }
    if (window.location.pathname.indexOf('odzid') > -1 && (this.getQuery('dataType') || this.getQuery('forwardId'))) {
      if(this.getQuery('childContentId')){
        window.document.title = $('div.mainTitle').text()
      }else{
        window.document.title = title
      }
      
    }

    //在套壳页面
    if (self != top) {
      try {
        let reg = new RegExp('(^|&)id=([^&]*)(&|$)')
        let r = parent.window.location.search.substr(1).match(reg) //substr() 的参数指定的是子串的开始位置和长度
        if (r != null) {
          // 对参数值进行解码
          r = decodeURI(r[2])
        } else {
          r = ''
        }
        if (parent.window.location.pathname.indexOf('odzid') > -1 && r) {
          parent.document.title = title
        }
      } catch (e) {
        console.error(e.message)
      }
    }
    Bus.$emit('changeName', title)
    _this.weixinShare(title, _this.summary, decodeURIComponent(_this.picurl))
    window.addEventListener('message', _this.shareFathod)

    //触发点赞收藏
    Bus.$on('dianzan', (t, b) => {
      if (t) {
        this.changOption()
      }
      if (b) {
        this.changOptions()
      }
    })
    //触发好友圈
    Bus.$on('businessCircle', (t) => {
      if (t) {
        this.repeat(2)
      }
    })
    //触发到商圈、好友
    Bus.$on('forwardTo', (t, y, z, name) => {
      if (this.dataType == parseInt(y)) {
        if (t == 8) {
          this.repeat(8, z, name)
        } else if (t == 9) {
          this.repeat(9, z, name)
        }
      }
    })
  },
  beforeDestroy() {
    Bus.$off('businessCircle')
    Bus.$off('forwardTo')
  },
  deactivated() {
    window.removeEventListener('message', this.shareFathod)
  },
  watch: {
    '$store.state.userInfo': function (val) {
      this.otherData()
      this.contentData()
      this.userId = val ? val.userId : this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('noLoginSid')
      this.userName = val ? val.trueName : this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('wxud')
    },
    '$store.state.Barrage': function (val) {
      if (val && this.dataType == 2) {
        this.barrageCont.unshift(val)
      }
    }
  },
  methods: {
    shareFathod(e) {
      var _this = this
      if (_this.dataType != Number(window.$flowDetailNum) && window.location.pathname.indexOf('flowDetail') > -1) return
      var e = e || window.event
      var url = encodeURIComponent((_this.getQuery('dataType') ? window.location.href : window.location.href.replace('flowDetail', 'odzid') + '&dataType=' + window.$dataType) + '&topType=hide&showMore=true')
      if (self != top && parent.location.href.split('=').length == 2) {
        url = encodeURIComponent(parent.location.href + '&topType=hide&showMore=true')
      }

      let target = document.createElement('textarea') //创建input节点
      async function val() {
        let resq = await _this.$http.get('/acnid-project-approve/custom/dwzUrl/transfor', { url: encodeURIComponent(window.location.href + '&topType=hide&showMore=true') })
        let link = _this.$store.state.baseURL + '/acnid-project-approve/custom/dwzUrl?id=' + resq.data
        target.value = _this.titleCont + '\n' + _this.summary + '\n' + _this.textBody + '\n' + _this.textEnding + '\n- ' + _this.appName + '\n' + link // 给input的value赋值
        document.body.appendChild(target) // 向页面插入input节点

        target.select() // 选中input
        document.execCommand('Copy') // 执行浏览器复制命令
        target.remove()

        if (e.data && typeof e.data == 'string' && e.data.indexOf('webpackHotUpdate') == -1) {
          layer.confirm(
            '内容已复制至剪贴板，去分享吧~',
            {
              btn: ['确定', '取消']
            },
            function (index, layero) {
              layer.close(index)
              var name = e.data.split('-')[0]
              let text = _this.$router.resolve({ path: 'weixin', query: { url: link } })
              switch (name) {
                case '微信朋友圈':
                  _this.judge('WEIXIN_CIRCLE', url, _this.titleCont, _this.picurl, _this.summary, _this.$store.state.baseURL + text.href + '&WX=1', '微信朋友圈', '', 'specail')
                  break
                case '新浪微博':
                  var _shareUrl = 'https://service.weibo.com/share/share.php?' //真实的appkey ，必选参数
                  _shareUrl += 'url=' + encodeURIComponent(link) //参数url设置分享的内容链接|默认当前页location，可选参数
                  _shareUrl += '&title=' + _this.titleCont //参数title设置分享的标题|默认当前页标题，可选参数
                  _shareUrl += '&pic=' + _this.picurl.replace(/https/g, 'http') //参数pic设置图片链接|默认为空，可选参数
                  _this.judge('SINA', url, _this.titleCont, _this.picurl, _this.summary, _shareUrl, '新浪微博', '', 'specail')
                  break
                case 'QQ空间':
                  var _shareUrl = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?'
                  _shareUrl += 'url=' + url //参数url设置分享的内容链接|默认当前页urllocation
                  _shareUrl += '&title=' + _this.titleCont //参数title设置分享标题title，可选参数
                  _shareUrl += '&summary=' + _this.longtext(_this.summary, 200) //参数title设置分享标题title，可选参数
                  _shareUrl += '&pics=' + _this.picurl //参数pic设置图片链接|默认为空，可选参数
                  _this.judge('QZONE', url, _this.titleCont, _this.picurl, _this.summary, _shareUrl, 'QQ空间', '', 'specail')
                  break
                case 'QQ':
                  var shareqqzonestring = ' http://connect.qq.com/widget/shareqq/index.html?title=' + title + '&url=' + url + '&pic=' + _this.picurl
                  _this.judge('QQ', url, _this.titleCont, _this.picurl, _this.summary, shareqqzonestring, 'QQ', '', 'specail')
                  break
                case '微信好友':
                  _this.judge('WEIXIN', url, _this.titleCont, _this.picurl, _this.summary, _this.$store.state.baseURL + text.href + '&WX=1', '微信好友', '', 'specail')
                  break
                case '微信':
                  _this.judge('WEIXIN', url, _this.titleCont, _this.picurl, _this.summary, _this.$store.state.baseURL + text.href + '&WX=1', '微信', '', 'specail')
                  break
                case '抖音':
                  _this.judge('DOUYIN', url, _this.titleCont, _this.picurl, _this.summary, e.data.split('-')[1], '抖音')
                  break
                case '钉钉好友':
                  _this.judge('DINGTALK', url, title, _this.picurl, _this.summary, _this.$store.state.baseURL + text.href + '&DD=1', '钉钉好友')
                  break
                case '快手':
                  _this.judge('KUAISHOU', url, _this.titleCont, _this.picurl, _this.summary, e.data.split('-')[1], '快手')
                  break
                default:
                  if (_this.IsMobile()) {
                    _this.jumpToApp('', e.data.split('-')[1], '', '', '', name, JSON.parse('{' + e.data.split('{')[1]))
                  } else {
                    if (navigator.userAgent.indexOf('Electron') > -1) {
                      var sendData = {
                        url: e.data.split('-')[1],
                        data: ''
                      }
                      switch (name) {
                        case '简书':
                          sendData.data = {
                            title: _this.titleCont,
                            content: (_this.summary ? '<p>' + _this.summary + '</p>' : '') + (_this.textBody ? '<p>' + _this.textBody + '</p>' : '') + (_this.textEnding ? '<p>' + _this.textEnding + '</p>' : '') + (link ? '<p>' + link + '</p>' : '')
                          }
                          _this.specialTreatment(sendData)
                          break
                        case '知乎':
                          sendData.data = {
                            title: _this.titleCont,
                            content: (_this.summary ? _this.summary + '-' : '') + (_this.textBody ? _this.textBody + '-' : '') + (_this.textEnding ? _this.textEnding + '-' : '') + (link ? link : '')
                          }
                          _this.specialTreatment(sendData)
                          break
                        case '今日头条':
                          sendData.data = {
                            title: '<div class="editor-title autofit-textarea-wrapper"><pre class="autofit-textarea-content">' + _this.titleCont + '</pre><textarea placeholder="请输入文章标题（2～30个字）" autocomplete="off">' + _this.titleCont + '</textarea></div>',
                            content: (_this.summary ? '<p>' + _this.summary + '</p>' : '') + (_this.textBody ? '<p>' + _this.textBody + '</p>' : '') + (_this.textEnding ? '<p>' + _this.textEnding + '</p>' : '') + (link ? '<p>' + link + '</p>' : '')
                          }
                          _this.specialTreatment(sendData)
                          break
                        case '搜狐':
                          sendData.data = {
                            title: '<input data-v-fc117650="" type="text"  placeholder="请输入标题（5-36字）" value="' + _this.titleCont + '">',
                            content: (_this.summary ? '<p>' + _this.summary + '</p>' : '') + (_this.textBody ? '<p>' + _this.textBody + '</p>' : '') + (_this.textEnding ? '<p>' + _this.textEnding + '</p>' : '') + (link ? '<p>' + link + '</p>' : '')
                          }
                          _this.specialTreatment(sendData)
                          break
                        case '微信公众号':
                          sendData.data = {
                            title: _this.titleCont,
                            content: (_this.summary ? '<p>' + _this.summary + '</p>' : '') + (_this.textBody ? '<p>' + _this.textBody + '</p>' : '') + (_this.textEnding ? '<p>' + _this.textEnding + '</p>' : '') + (link ? '<p>' + link + '</p>' : ''),
                            author: _this.appName
                          }
                          _this.specialTreatment(sendData)
                          break
                        case '百家号':
                          sendData.data = {
                            title: _this.titleCont,
                            content: (_this.summary ? '<p>' + _this.summary + '</p>' : '') + (_this.textBody ? '<p>' + _this.textBody + '</p>' : '') + (_this.textEnding ? '<p>' + _this.textEnding + '</p>' : '') + (link ? '<p>' + link + '</p>' : '')
                          }
                          _this.specialTreatment(sendData)
                          break
                        default:
                          _this.open(e.data.split('-')[1], '_blank')
                      }
                    } else {
                      _this.open(e.data.split('-')[1], '_blank')
                    }
                  }
              }
            }
          )
        }
      }
      val()
    },
    barrageChange() {
      this.barrage = !this.barrage
    },
    sendMessage() {
      if (!this.barrageData) return
      var timestamp = new Date().getTime()
      var chatmsg = { cm: this.barrageData, t: 3, uid: timestamp.toString() }
      this.$IM.send(this.$IM.baseData(68, chatmsg))
      this.barrageData = ''
      $('.introduce-l-barrage ul').scrollTop($('.introduce-l-barrage ul')[0].scrollHeight)
    },
    //打开layer弹窗
    openLayerWin(url) {
      layer.open({
        type: 2,
        title: false,
        closeBtn: 1,
        area: ['80%', '80%'],
        content: url //iframe的url
      })
      return
    },
    repeats() {
      this.showL = false
      this.showP = !this.showP
      this.suspendShow = false
      window.$flowDetailNum = this.dataType
      sessionStorage.setItem('contentDatas', JSON.stringify(this.contentId))
    },
    //删除
    deletes(id) {
      this.$http
        .get('/zciid-deliverable/interface/deliverables/delete/comment.json', {
          id: id
        })
        .then((res) => {
          if (res.message == '评论删除成功') {
            this.contentData()
          }
        })
    },
    getUrl(menuName) {
      var startUrl = '',
        _this = this
      if (menuName == '转发到商圈') {
        startUrl = _this.$store.state.baseURL + '/zciid-deliverable/interface/deliverables/transmit/circle/list?contentId='
      } else if (menuName == '分享') {
        var link
        link = _this.$store.state.baseURL + '/zciid-deliverable/api/issue/issueApp?issueType=8&contentIdStr=' + _this.$contentId + '&contentIdStrName=' + _this.titleCont + '&userId=' + _this.userId + '&userName=' + _this.userName + '&pfId=' + window.$pfId + '&appId=' + _this.contentId[0][0].appId
        return link
      }
      var url =
        startUrl +
        _this.contentIds +
        '&creatUserId=' +
        _this.otherDatas.userId +
        '&creatUserName=' +
        _this.otherDatas.userName +
        '&userId=' +
        _this.userId +
        '&userName=' +
        _this.userName +
        '&photo=' +
        _this.photo +
        '&transmitUrl=' +
        encodeURIComponent(_this.getQuery('dataType') ? window.location.href : window.location.href.replace('flowDetail', 'odzid') + '&dataType=' + window.$dataType) +
        '&stanardByAppNameData=' +
        _this.otherDatas.stanardByAppNameData +
        '&stanardByMainFigureData=' +
        _this.otherDatas.stanardByMainFigureData +
        '&stanardByBasicPriceData=' +
        _this.otherDatas.stanardByBasicPriceData +
        '&stanardByVideoShowData=' +
        _this.otherDatas.stanardByVideoShowData +
        '&pfId=' +
        window.$pfId
      // if (menuName == '重新转发') {
      //   url = _this.$store.state.baseURL + '/zciid-deliverable/api/issue/socialAnewIssue?anew=anew&pfId=' + window.$pfId + '&userId=' + _this.userId + '&contentId=' + _this.$contentId + '&contentName=' + _this.titleCont
      // }
      if (menuName == '更新发布') {
        url = _this.$store.state.baseURL + '/zciid-deliverable/api/issue/siteWindowCreateIframe?openType=update&floorType=floor&pfId=' + window.$pfId + '&userId=' + _this.userId + '&contentId=' + _this.$contentId + '&contentName=' + _this.titleCont
      }
      if (menuName == '直接转发' || menuName == '重新转发') {
        url = _this.$store.state.baseURL + '/zciid-deliverable/grab/start/edit?id=' + _this.$contentId + '&userId=' + _this.userId + '&userName=' + _this.userName  + '&dataType=forward'
      }
      return url
    },
    toOpen() {
      var url = this.$store.state.baseURL + '/cme-sso-app/product/circle/friends/list?pfId=' + window.$pfId
      if (!this.suspend) {
        layer.open({
          type: 2,
          title: '转发到好友圈',
          area: ['100%', '100%'],
          content: url
        })
      } else {
        // Bus.$emit('check', url);
        // window.location.href = url;
        this.open(url, '_self', '转发到好友圈')
      }
      this.$notify.closeAll()
    },
    //转发
    repeat(ind, z, menuName) {
      // if (!this.$store.state.userInfo.userId) {
      //   this.handleLoginAuth();
      //   return;
      // }
      window.$dataType = this.dataType
      if (this.suspend && ind != 2) {
        //在新详情页
        if (!this.suspendShow && document.documentElement.clientWidth > 768) {
          this.suspendShow = true
        } else if (ind == this.index) {
          this.suspendShow = false
        }
        if (ind != this.index) {
          var url = this.getUrl(menuName)
          if (this.IsMobile() || document.documentElement.clientWidth <= 768) {
            this.openLayerWin(url)
            return
          }
          setTimeout(() => {
            if (z) {
              Bus.$emit('changeIfameUrl', url, menuName)
            } else {
              $('#iframe').attr('src', url)
            }
          }, 100)
        }
        if (z) return
        this.index = ind
      } else {
        //在老详情页
        if (ind == 2) {
          this.suspendShow = false
          var type = 1
          if (!this.pic && text) {
            type = 1
          } else if (this.isPic(this.pic) && text) {
            type = 2
          } else if (this.isVideo(this.pic) && text) {
            type = 3
          } else if (!this.pic && !text) {
            this.$notify({
              title: '提示',
              message: '交付物为空！',
              type: 'warning'
            })
          }
          this.$http
            .get('/cme-sso-app/product/circle/add-circle-content', {
              userId: this.userId,
              type: type,
              text: this.contentId[0][0].standardData,
              pics: this.pic,
              share: '520浏览器',
              pms: 1,
              issueType: 2,
              linkUrl: this.getQuery('dataType') ? window.location.href : window.location.href.replace('flowDetail', 'odzid') + '&dataType=' + window.$dataType
            })
            .then((res) => {
              if (res.state == 1) {
                const h = this.$createElement
                this.$notify({
                  title: '提示',
                  dangerouslyUseHTMLString: true,
                  type: 'success',
                  duration: 0,
                  message: h('div', { class: 'personnel' }, [
                    h('p', { class: 'isCreate' }, '请在好友圈查看！'),
                    h(
                      'button',
                      {
                        class: 'personnel-btn',
                        on: {
                          click: this.toOpen
                        }
                      },
                      '查看'
                    )
                  ])
                })
              }
            })
        } else {
          var url = this.getUrl(menuName)
          if (this.IsMobile() || document.documentElement.clientWidth <= 768) {
            this.openLayerWin(url)
            return
          }
          layer.open({
            type: 2,
            title: menuName,
            area: ['100%', '100%'],
            content: url
          })
        }
      }
    },
    //获取必要参数
    otherData() {
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/get/getContentByIdAndStandardId.json', {
          contentId: this.contentIds ? this.contentIds : this.$contentId
        })
        .then((res) => {
          if (res.state == 1) {
            this.creatUserId = res.data.userId
            this.otherDatas = res.data
            this.$store.commit('setContentIds', { contentIds: this.contentIds, otherDatas: res.data, dataType: this.dataType, userName: this.userName, photo: this.photo, userId: this.userId, appId: this.contentId[0][0].appId, titleCont: this.titleCont })
          }
        })
    },
    isPic(url) {
      if ((url && typeof url == 'string' && url.indexOf('.png') > 0) || (url && typeof url == 'string' && url.indexOf('.jpg') > 0)) {
        return true
      }
      return false
    },
    //筛选数据中第一张图片
    filtrateOnePics(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = 0; j < arr[i].length; j++) {
          if (this.isPic(arr[i][j].standardData) || this.isVideo(arr[i][j].standardData)) {
            this.pic = arr[i][j].standardData
            break
          }
        }
      }
    },
    //提交
    sub() {
      if (!this.notedata) {
        this.$notify({
          title: '提示',
          message: '请评论后，再提交',
          type: 'warning',
          duration: 2000
        })
        return false
      }
      if (this.placeholder.indexOf('评论') > -1) {
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/comment.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            texts: this.notedata,
            stanardByAppNameData: this.longtext(this.otherDatas.stanardByAppNameData, 15),
            stanardByMainFigureData: this.otherDatas.stanardByMainFigureData,
            stanardByProductBriefData: this.longtext(this.otherDatas.stanardByProductBriefData, 15),
            stanardByBasicPriceData: this.longtext(this.otherDatas.stanardByBasicPriceData, 15),
            stanardByVideoShowData: this.longtext(this.otherDatas.stanardByVideoShowData, 15)
          })
          .then((res) => {
            if (res.state == 1) {
              this.contentData()
              this.reflex = false
              this.notedata = ''
              // var text = document.getElementsByClassName("line");
              // if(text){
              //   text[0].scrollIntoView({ behavior: "smooth" });
              // }
            }
          })
      } else {
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/comment.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            toUserId: this.content[this.newIndex].userId,
            toUserName: this.content[this.newIndex].userName,
            photo: this.photo,
            standardData: this.pic ? this.pic : '',
            texts: this.notedata,
            stanardByAppNameData: this.longtext(this.otherDatas.stanardByAppNameData, 15),
            stanardByMainFigureData: this.otherDatas.stanardByMainFigureData,
            stanardByProductBriefData: this.longtext(this.otherDatas.stanardByProductBriefData, 15),
            stanardByBasicPriceData: this.longtext(this.otherDatas.stanardByBasicPriceData, 15),
            stanardByVideoShowData: this.longtext(this.otherDatas.stanardByVideoShowData, 15)
          })
          .then((res) => {
            if (res.state == 1) {
              this.contentData()
              this.reflex = false
              this.notedata = ''
            }
          })
      }
    },
    //初始化
    contentData() {
      this.$http
        .get('/zciid-deliverable/interface/deliverables/allComment/list.json', {
          contentId: this.contentIds,
          userId: this.userId,
          userName: this.userName
        })
        .then((res) => {
          if (res.state == 1) {
            this.initData = res.data
            this.$store.commit('setInitData', { data: res.data, content: this.contentIds })
            this.content = res.data.commentTexts
          }
        })
      this.$http
        .get('/zciid-deliverable/business/bAppOqmidPage/getDataForOqimd.json', {
          appId: this.getQuery('appId')
        })
        .then((res) => {
          if (res.state == 1) {
            this.appName = res.data.appName
          }
        })
    },
    //点赞
    changOption(t) {
      if (!parseInt(this.initData.like)) {
        //点赞
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/like.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            stanardByAppNameData: this.longtext(this.otherDatas.stanardByAppNameData, 15),
            stanardByMainFigureData: this.otherDatas.stanardByMainFigureData,
            stanardByProductBriefData: this.longtext(this.otherDatas.stanardByProductBriefData, 15),
            stanardByBasicPriceData: this.longtext(this.otherDatas.stanardByBasicPriceData, 15),
            stanardByVideoShowData: this.longtext(this.otherDatas.stanardByVideoShowData, 15)
          })
          .then((res) => {
            if (res.state == 1) {
              this.initData.like = 1
              this.initData.likeNum = this.initData.likeNum + 1
              if (t) {
                Bus.$emit('dianzaiFanxian', 1, this.initData.likeNum)
              }
            }
          })
          .then(() => {
            this.contentData()
          })
      } else {
        //取消点赞
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/like.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            stanardByAppNameData: this.longtext(this.otherDatas.stanardByAppNameData, 15),
            stanardByMainFigureData: this.otherDatas.stanardByMainFigureData,
            stanardByProductBriefData: this.longtext(this.otherDatas.stanardByProductBriefData, 15),
            stanardByBasicPriceData: this.longtext(this.otherDatas.stanardByBasicPriceData, 15),
            stanardByVideoShowData: this.longtext(this.otherDatas.stanardByVideoShowData, 15)
          })
          .then((res) => {
            if (res.state == 1) {
              if (this.initData.likeNum == 0) {
                return
              } else {
                this.initData.like = 0
                this.initData.likeNum = this.initData.likeNum - 1
                if (t) {
                  Bus.$emit('dianzaiFanxian', 0, this.initData.likeNum)
                }
              }
            }
          })
          .then(() => {
            this.contentData()
          })
      }
    },
    statistics(operateNum) {
      var _this = this
      if (!_this.$store.state.userInfo.userId) return
      $.ajax({
        url: _this.$store.state.baseURL + '/zciid-deliverable/api/deliverable/manage/addInfo',
        data: {
          //固定：3
          operateType: '3',
          //当前登录人userId
          userId: _this.$store.state.userInfo.userId,
          //交付物名称
          name: document.title,
          //交付物url eg：https://520emv.com/xxx,
          deliverableUrl: location.href,
          //简介
          brief: _this.longtext(_this.summary, 50),
          //收藏量
          operateNum: operateNum,
          //交付物id 数据id(或其他唯一标识)-type3   eg：UUID-type3
          deliverableId:
            (_this.getQuery('docId') ||
              _this.getQuery('thirdUrl') ||
              _this.getQuery('productUrl') ||
              _this.getQuery('deviceId') ||
              _this.getQuery('devicekbId') ||
              _this.getQuery('platformUrl') ||
              _this.getQuery('id') ||
              _this.$contentId ||
              _this.getQuery('pfId') ||
              _this.getQuery('emailId') ||
              _this.getQuery('ywId') ||
              _this.getQuery('exploitId')) + '-type3',
          img: $('img.z-image').length ? $('img.z-image')[0].src : ''
        },
        type: 'GET',
        dataType: 'json'
      })
    },
    //收藏
    changOptions(t) {
      if (!parseInt(this.initData.collect)) {
        //收藏
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/collect.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            stanardByAppNameData: this.longtext(this.otherDatas.stanardByAppNameData, 15),
            stanardByMainFigureData: this.otherDatas.stanardByMainFigureData,
            stanardByProductBriefData: this.longtext(this.otherDatas.stanardByProductBriefData, 15),
            stanardByBasicPriceData: this.longtext(this.otherDatas.stanardByBasicPriceData, 15),
            stanardByVideoShowData: this.longtext(this.otherDatas.stanardByVideoShowData, 15)
          })
          .then((res) => {
            if (res.state == 1) {
              this.initData.collect = 1
              this.initData.collectNum = this.initData.collectNum + 1
              if (t) {
                Bus.$emit('shoucangFanxian', 1, this.initData.collectNum)
              }
              this.statistics(this.initData.collectNum)
            }
          })
      } else {
        //取消收藏
        this.$http
          .get('/zciid-deliverable/interface/deliverables/update/collect.json', {
            contentId: this.contentIds,
            userId: this.userId,
            userName: this.userName,
            photo: this.photo,
            stanardByAppNameData: this.longtext(this.otherDatas.stanardByAppNameData, 15),
            stanardByMainFigureData: this.otherDatas.stanardByMainFigureData,
            stanardByProductBriefData: this.longtext(this.otherDatas.stanardByProductBriefData, 15),
            stanardByBasicPriceData: this.longtext(this.otherDatas.stanardByBasicPriceData, 15),
            stanardByVideoShowData: this.longtext(this.otherDatas.stanardByVideoShowData, 15)
          })
          .then((res) => {
            if (res.state == 1) {
              if (this.initData.collectNum == 0) {
                return
              } else {
                this.initData.collect = 0
                this.initData.collectNum = this.initData.collectNum - 1
                if (t) {
                  Bus.$emit('shoucangFanxian', 0, this.initData.collectNum)
                }
                this.statistics(this.initData.collectNum)
              }
            }
          })
      }
    },
    pinglun(){
      this.showP = false
      this.showL = !this.showL
      this.suspendShow = false
    },
    plrepeat(ind){
      if(!ind){
        this.reflexs()
      }else{
        layer.open({
          id: 'transpond',
          type: 2,
          title: '对话',
          fixed: true,
          maxmin: true,
          area: ['100%', '100%'],
          content: '/aassid/tag/con/middleIndex?floorWinType=1&pfId='+ window.$pfId +'&nowReceiveId='+ this.getQuery('contentId') + (this.$store.state.userInfo.userId ? '' : ('&wxud=' + localStorage.getItem('wxud'))),
          close: function () {}
        })
      }
    },
    //评论和回复
    reflexs(name, ind) {
      //点击评论
      if (!this.reflex && !name) {
        this.reflex = true
        this.newIndex = -1
      } else {
        //点击回复
        if (name) {
          if (!this.reflex) {
            this.reflex = true
            this.newIndex = ind
          } else {
            //评论框已显示,并且第二次点击是同一个
            if (ind == this.newIndex) {
              this.reflex = false
            }
            this.newIndex = ind
          }
        } else {
          //再次点击评论
          if (!(this.placeholder.indexOf('回复') > -1 && this.reflex)) {
            this.reflex = false
          }
          this.newIndex = -1
        }
      }
      if (this.$store.state.userInfo.trueName) {
        if (name && name.userName != this.$store.state.userInfo.trueName) {
          this.placeholder = '回复 ' + name.userName
        } else {
          this.placeholder = '评论'
        }
      } else {
        if (name && name.userName != (this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('wxud'))) {
          this.placeholder = '回复 ' + name.userName
        } else {
          this.placeholder = '评论'
        }
      }

      setTimeout(() => {
        var text = document.getElementById('textarea')
        if (text) {
          this.autoTextarea(text)
          // text.scrollIntoView({ behavior: "smooth" });
        }
      })
    },
    longtext(str, num) {
      if (str && str.length > num) {
        str = str.substr(0, num) + '...'
      }
      return str
    }
  }
}
</script>
<style>
.layui-layer-iframe {
  overflow: visible !important;
}
</style>
<style scoped>
.introduce {
  display: flex;
  justify-content: space-between;
  height: 16px;
  line-height: 16px;
  margin-top: 20px;
}
.introduce-r span {
  margin-left: 6px;
  font-size: 14px;
  color: #666666;
}
.introduce-l,
.introduce-r {
  display: flex;
  justify-content: space-between;
  position: relative;
}
.introduce-r .introduce-r-p {
  width: 110px;
  height: 78px;
  background-color: #fff;
  position: absolute;
  top: -96px;
  
  z-index: 1000;
  -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.introduce-r .introduce-r-p.zhuanfa{
  left: 175px;
}
.introduce-r .introduce-r-p.pinglun{
  left: 13px;
}
.introduce-r .introduce-r-p:after {
  content: '';
  border-top: 8px solid #fff;
  border-right: 8px solid transparent;
  border-bottom: none;
  border-left: 8px solid transparent;
  position: absolute;
  bottom: -8px;
  right: 50%;
  margin-right: -8px;
}

.introduce-r-p .suspend {
  padding: 13px 10px 0;
  line-height: 20px;
  cursor: pointer;
}
.introduce-r-p .suspend:hover{
  color: #0c78cf;
}
.introduce-l .introduce-r-div,
.introduce-r .introduce-r-div {
  display: flex;
  cursor: pointer;
}
.introduce-r .introduce-r-div {
  margin-left: 14px;
}
.introduce-l .introduce-time {
  margin-left: 26px;
}
.introduce-l-barrage {
  position: absolute;
  left: 40px;
  bottom: 170px;
  z-index: 99;
}
.introduce-l-barrage ul {
  height: 250px;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
}
.introduce-l-barrage ul::-webkit-scrollbar {
  width: 0px !important;
}
.introduce-l-barrage li {
  margin-top: 8px;
  width: 320px;
}
.introduce-l-barrage li span {
  background-color: rgba(34, 34, 34, 0.7);
  line-height: 18px;
  color: #fff;
  display: inline-block;
  border-radius: 4px;
  padding: 5px 10px;
  word-break: break-all;
}
.introduce-l-input {
  display: flex;
  align-items: center;
  position: absolute;
  top: -10px;
  height: 40px;
}
.introduce-l-input img {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-right: 20px;
}
.introduce-l-input input {
  border: none;
  height: 100%;
  width: 800px;
  font-size: 14px;
  color: #666;
  border-radius: 4px 0 0 4px;
  background-color: #efefef;
}
.introduce-l-input button {
  border-radius: 0 4px 4px 0;
  height: 100%;
  width: 64px;
  font-size: 14px;
  background-color: #4c9dfb;
  color: #ffffff;
  vertical-align: bottom;
}
.comment {
  margin-top: 16px;
  height: 350px;
  height: calc(35% - 32px);
  max-height: 300px;
  overflow-y: auto;
}
.LikePeople {
  padding: 6px 8px 6px 28px;
  border-radius: 5px;
  background: #f0f7ff url('../../assets/image/images/fabulous_curr.png') 8px 8px/12px no-repeat;
  cursor: pointer;
}
.LikePeople span {
  font-size: 12px;
  padding: 0 4px 0 0;
  color: #2f8eed;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
}
.LikePeople span[title]:hover:after {
  content: attr(title);
  color: #fff;
  padding: 4px 8px;
  position: absolute;
  left: 0;
  top: -160%;
  z-index: 20;
  background-color: rgba(37, 39, 42, 0.85);
}
.comment .line {
  margin-top: 6px;
  display: flex;
  justify-content: space-between;
}
.comment .line .line-l {
  color: #666666;
}
.comment .line .line-l .rep {
  font-size: 14px;
  color: #666666;
}
@media screen and (max-width: 768px) {
  .comment .line .delete {
    margin-left: 5px !important;
  }
  .comment .line .line-r {
    width: 107px !important;
  }
  .comment .line .line-l {
    width: calc(100% - 107px);
  }
  .introduce-l-input {
    top: -50px;
    width: calc(100vw - 58px);
  }
  .introduce-l-input input {
    width: calc(100vw - 150px);
  }
  .specialStyle {
    margin-top: 60px;
  }
}
.comment .line .line-r {
  display: flex;
  flex-direction: row-reverse;
  width: 118px;
}
.comment .line .line-l {
  width: calc(100% - 118px);
}
.comment .line .reply {
  display: flex;
  height: 14px;
  width: 49px;
  font-size: 13px;
  line-height: 14px;
  color: #666666;
  cursor: pointer;
  margin: 4px 0 0 4px;
}
.comment .line .delete {
  height: 14px;
  width: 49px;
  line-height: 14px;
  font-size: 13px;
  margin-top: 4px;
  color: #666666;
  margin-left: 16px;
}
.comment .line .delete > div {
  display: flex;
  cursor: pointer;
}
.comment .line .reply span,
.delete span {
  margin-left: 6px;
}
.comment .name {
  font-size: 14px;
  cursor: pointer;
  color: #0c78cf;
}
/* .comment .name:hover {
  color: #0c78cf;
  text-decoration: underline;
  text-underline-position: under
} */
.comment .content {
  font-size: 14px;
  color: #666666;
  line-height: 24px;
}
.comment .reflex {
  margin: 12px 0 0;
  border: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}
.comment .reflex textarea {
  border: none;
  resize: none;
  overflow-y: hidden;
  font-size: 14px;
  line-height: 24px;
  height: 45px;
}
.personnel {
  width: 262px;
  display: flex;
  justify-content: space-between;
}
.personnel-btn {
  cursor: pointer;
  border-radius: 3px;
  color: #fff;
  border: 1px solid #2f8eed;
  background-color: #2f8eed;
}
/* .personnel-btn:hover{
  background-color: #67C23A;
} */
.comment .reflex .Submit button {
  float: right;
  width: 100px;
  height: 30px;
  margin: 8px;
  color: #ffffff;
  background-color: #0d78cf;
  border-radius: 3px;
}
@media screen and (max-width: 768px) {
  .introduce-r .introduce-r-p.zhuanfa {
    position: absolute !important;
    left: 63px;
  }
  /* .comment .line .line-l{width:auto;} */
  /* .comment .line .reply{width:100px;justify-content:flex-end;} */
}
</style>



// WEBPACK FOOTER //
// src/components/flowDetail/pinglun.vue